// ACTIONS
export const FIND_PLACES = 'offerzen/places/FIND_PLACES'
const FIND_PLACES_FETCHING = 'offerzen/places/FIND_PLACES_FETCHING'
const FIND_PLACES_SUCCESS = 'offerzen/places/FIND_PLACES_SUCCESS'
const FIND_PLACES_FAILED = 'offerzen/places/FIND_PLACES_FAILED'
const CLEAR_PLACES_DATA = 'offerzen/places/CLEAR_PLACES_DATA'

// ACTION CREATORS
export const findPlaces = term => ({
  // To be cleaned up after Geoapify feature is live
  type: FIND_PLACES,
  payload: {
    term,
  },
})

export const clearPlacesData = () => ({
  type: CLEAR_PLACES_DATA,
  payload: {
    data: [],
  },
})

export const findPlacesFetching = value => ({
  type: FIND_PLACES_FETCHING,
  payload: {
    fetching: value,
  },
})

export const findPlacesSuccess = data => ({
  type: FIND_PLACES_SUCCESS,
  payload: {
    fetching: false,
    data,
  },
})

export const findPlacesFailed = error => ({
  type: FIND_PLACES_FAILED,
  payload: {
    fetching: false,
    error: true,
    errorMessage: error,
  },
})

// REDUCERS
const initialState = {
  term: '',
  fetching: false,
  data: [],
  error: false,
  errorMessage: '',
}

const placesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CLEAR_PLACES_DATA:
      return {
        ...state,
        data: action.payload.data,
        error: false,
        errorMessage: '',
      }

    case FIND_PLACES_FETCHING:
      return {
        ...state,
        fetching: action.payload.fetching,
      }

    case FIND_PLACES_SUCCESS:
      return {
        ...state,
        fetching: action.payload.fetching,
        data: [...action.payload.data],
      }

    case FIND_PLACES_FAILED:
      return {
        ...state,
        fetching: action.payload.fetching,
        error: action.payload.error,
        errorMessage: action.payload.errorMessage,
      }

    default:
      return state
  }
}

export default placesReducer
